<template>
  <div>
    <p>Abmeldung in Progress..</p>
  </div>
</template>

<script>
export default {
  name: "SigningIn"
}
</script>

<style scoped>

</style>
